import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsChangelogPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/changelog.js